"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = require("../Box");
var _Flex = require("../Flex");
var _Image = require("../Image");
var _Text = require("../Text");
var _excluded = ["src", "initials", "size", "lazyLoad"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var LENGTHS = {
  xxs: 2,
  xs: 2,
  sm: 3,
  md: 4
};
var TOKENS = {
  fontWeight: "normal",
  color: "black100",
  bg: "transparent",
  xxs: {
    diameter: 30,
    variant: "xs"
  },
  xs: {
    diameter: 45,
    variant: "sm-display"
  },
  sm: {
    diameter: 70,
    variant: "md"
  },
  md: {
    diameter: 100,
    variant: "lg-display"
  }
};

/** An circular Avatar component containing an image or initials */
var Avatar = function Avatar(_ref) {
  var _TOKENS$size;
  var src = _ref.src,
    initials = _ref.initials,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
    _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
    boxProps = _splitBoxProps2[0],
    imageProps = _splitBoxProps2[1];
  var _ref2 = (_TOKENS$size = TOKENS[size]) !== null && _TOKENS$size !== void 0 ? _TOKENS$size : TOKENS.sm,
    diameter = _ref2.diameter,
    variant = _ref2.variant;
  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, _extends({
    size: diameter,
    bg: TOKENS.bg,
    border: src ? "transparent" : "1px solid",
    borderColor: "black15",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden"
  }, boxProps), initials && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: variant,
    fontWeight: TOKENS.fontWeight,
    color: TOKENS.color,
    lineHeight: 1
  }, initials.slice(0, LENGTHS[size])), src && /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
    src: src,
    width: "100%",
    height: "100%",
    lazyLoad: lazyLoad,
    alt: initials !== null && initials !== void 0 ? initials : ""
  }, imageProps))));
};
exports.Avatar = Avatar;
Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map